import * as React from 'react'
import { ErrorView } from '$views/components/Error/Error.model'
import { formatError } from '$views/components/Error/Error.mapper'

export const useFetch = <T>(service: any) => {
  const [response, setResponse] = React.useState<T>(undefined)
  const [error, setError] = React.useState<ErrorView>()
  const [loading, handleLoading] = React.useState<boolean>(true)
  const [showErrorNotification, handleShowErrorNotification] = React.useState<boolean>(false)

  const fetchData = React.useCallback(async () => {
    handleLoading(true)
    try {
      const res = await service()
      setResponse(res)
    } catch (fetchError) {
      const responseError = formatError(fetchError)
      setError(responseError)
      handleShowErrorNotification(true)
    }
    handleLoading(false)
  }, [])

  React.useEffect(() => {
    fetchData()
  }, [])

  return { response, setResponse, error, showErrorNotification, loading, handleShowErrorNotification }
}



// WEBPACK FOOTER //
// ./src/utils/hooks/useFetch.ts